import React, { useEffect, useState } from "react";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  notification,
  Button,
  Row,
  Col,
  Card,
  Tag,
  Select,
  Spin,
  Table,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import ChartCard from "../../charts/ChartCard";
import getDetalleVisitaPorTipo from "../../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import Export_autorizacion_imagen from "../Autorizacion_imagen/exportable.jsx/autorizacion_imagen_excel";

import { useSelector } from "react-redux";

Chart.register(...registerables, ChartDataLabels);
const { Option } = Select;

const InformeAutorizacionImagen = () => {
  const [data, setData] = useState(null);
  const [dataOriginal, setDataOriginal] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);

  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [numeroVisitaSeleccionado, setNumeroVisitaSeleccionado] =
    useState(null);
  const [rangoFechas, setRangoFechas] = useState(null);

  const [autorizacionesPorDepartamento, setAutorizacionesPorDepartamento] =
    useState({});
  const [autorizacionesPorMunicipio, setAutorizacionesPorMunicipio] = useState(
    {}
  );
  const [autorizacionesPorTipo, setAutorizacionesPorTipo] = useState({});

  const [autorizacionDetalleFecha, setAutorizacionDetalleFecha] = useState({});

  const [listDepartamento, setListDepartamento] = useState(null);
  const [listMunicipio, setListMunicipio] = useState(null);
  const [listSector, setListSector] = useState(null);
  const [listMunicipiosPorDepartamento, setListMunicipiosPorDepartamento] =
    useState(null);

  const sectores = ["Pecuaria", "Agrícola", "Servicios"];

  const descripciones = {
    uso_nombre: "Uso del nombre",
    uso_fotos_videos: "Uso de fotos y videos",
    uso_frases: "Uso de frases",
    uso_declaraciones: "Uso de declaraciones",
    uso_imagen: "Uso de la imagen",
    uso_entrevista: "Uso entrevista",
    uso_archivo_audiovisual: "Uso archivo audiovisual",
    uso_otro: "Otro uso",
  };

  const usernameFromState = useSelector((state) => state.auth.user);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const fetchData = async () => {
    try {
      const response = await getDetalleVisitaPorTipo(
        4,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status) {
        // Aplanar la data
        const flatResults = results.map((item) => ({
          ...item,
          ...item.detalle, // Desestructuramos el contenido de detalle al mismo nivel
        }));

        setData(flatResults);
        setDataOriginal(flatResults);
        setDataFilter(flatResults);

        // Ahora puedes acceder directamente sin usar .detalle
        const departamentos = [
          ...new Set(flatResults.map((p) => p.departamento_p)),
        ];
        setListDepartamento(departamentos);

        const municipiosPorDepartamento = flatResults.reduce((acc, p) => {
          if (!acc[p.departamento_p]) {
            acc[p.departamento_p] = new Set();
          }
          acc[p.departamento_p].add(p.municipio_p);
          return acc;
        }, {});
        setListMunicipiosPorDepartamento(municipiosPorDepartamento);
        setListSector(sectores);

        calcularIndicadores(flatResults);
      } else {
        notification.error({ message: response.message });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  useEffect(() => {
    if (!data) return;

    let visitasFiltradas = [...data];

    if (departamentoSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.departamento_p === departamentoSeleccionado
      );

      // Lista de municipios filtrados por el departamento seleccionado
      const municipios = departamentoSeleccionado
        ? [...listMunicipiosPorDepartamento[departamentoSeleccionado]]
        : [];
      setListMunicipio(municipios);
    }

    if (municipioSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.municipio_p === municipioSeleccionado
      );
    }

    if (sectorSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.linea_productiva === sectorSeleccionado
      );
    }

    calcularIndicadores(visitasFiltradas);
  }, [
    departamentoSeleccionado,
    municipioSeleccionado,
    sectorSeleccionado,
    numeroVisitaSeleccionado,
    rangoFechas,
    data,
  ]);

  useEffect(() => {
    fetchData();
  }, []);

  const obtenerTotalesPorAutorizacion = (data) => {
    const totales = {};

    data.forEach((item) => {
      if (Array.isArray(item.autorizaciones)) {
        item.autorizaciones.forEach((tipo) => {
          if (tipo && tipo.trim() !== "") {
            totales[tipo] = (totales[tipo] || 0) + 1;
          }
        });
      }
    });

    return totales;
  };

  const obtenerDetallePorFecha = (data) => {
    // Asegúrate de que los datos estén ordenados
    const mesTemp = {};

    // Agrupamos por año y mes
    data.forEach((p) => {
      const key = `${p.anio_firma}-${p.mes}`;
      if (!mesTemp[key]) {
        mesTemp[key] = {
          anio: p.anio_firma,
          mes: p.mes,
          total: 0,
        };
      }
      mesTemp[key].total += 1;
    });

    // Convertimos a array y le añadimos un id/index
    const resultado = Object.values(mesTemp).map((item, index) => ({
      id: index + 1, // Aquí podrías usar un id único basado en el año y mes si lo prefieres
      ...item,
    }));

    // Ordenamos por año y mes
    resultado.sort((a, b) => {
      // Primero comparamos el año
      if (a.anio !== b.anio) {
        return a.anio - b.anio;
      }

      // Si los años son iguales, comparamos el mes
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      return meses.indexOf(a.mes) - meses.indexOf(b.mes);
    });

    setAutorizacionDetalleFecha(resultado);
  };

  const calcularIndicadores = (datos) => {
    //Visitas por departamento
    const departamentosTemp = {};
    datos.forEach((p) => {
      departamentosTemp[p.departamento] =
        (departamentosTemp[p.departamento] || 0) + 1;
    });
    setAutorizacionesPorDepartamento(departamentosTemp);
    // Visitas por municipio (usando 'nacionalidad' si existe, si no 'municipio')
    const municipiosTemp = {};
    datos.forEach((p) => {
      const municipioClave = p.nacionalidad || p.municipio || "Desconocido";
      municipiosTemp[municipioClave] =
        (municipiosTemp[municipioClave] || 0) + 1;
    });

    setAutorizacionesPorMunicipio(municipiosTemp);

    const resultTotales = obtenerTotalesPorAutorizacion(datos);
    setAutorizacionesPorTipo(resultTotales);

    obtenerDetallePorFecha(datos);

    //Visitas por tema de capacitación
    setDataFilter(datos);
  };

  const columns = [
    {
      title: "Código SIRR",
      dataIndex: "id_participante",
      key: "id_participante",
      width: 150,
    },
    {
      title: "Nombre",
      dataIndex: "nombre_participante",
      key: "nombre_participante",
      width: 150,
    },
    {
      title: "Uso de nombre",
      key: "uso_nombre",
      render: (_, record) =>
        record.autorizaciones.includes("uso_nombre") ? "SI" : "NO",
      width: 150,
      align: "center",
    },
    {
      title: "Fotografías/Videos",
      key: "uso_fotos_videos",
      render: (_, record) =>
        record.autorizaciones.includes("uso_fotos_videos") ? "SI" : "NO",
      width: 160,
      align: "center",
    },
    {
      title: "Frases",
      key: "uso_frases",
      render: (_, record) =>
        record.autorizaciones.includes("uso_frases") ? "SI" : "NO",
      width: 100,
      align: "center",
    },
    {
      title: "Declaraciones Testimoniales",
      key: "uso_declaraciones",
      render: (_, record) =>
        record.autorizaciones.includes("uso_declaraciones") ? "SI" : "NO",
      width: 150,
      align: "center",
    },
    {
      title: "Imagen",
      key: "uso_imagen",
      render: (_, record) =>
        record.autorizaciones.includes("uso_imagen") ? "SI" : "NO",
      width: 150,
      align: "center",
    },
    {
      title: "Entrevista",
      key: "uso_entrevista",
      render: (_, record) =>
        record.autorizaciones.includes("uso_entrevista") ? "SI" : "NO",
      width: 150,
      align: "center",
    },
    {
      title: "Imagen de archivo audiovisual",
      key: "uso_archivo_audiovisual",
      render: (_, record) =>
        record.autorizaciones.includes("uso_archivo_audiovisual") ? "SI" : "NO",
      width: 200,
      align: "center",
    },
    {
      title: "Otro",
      key: "uso_otro",
      render: (_, record) =>
        record.autorizaciones.includes("uso_otro") ? "SI" : "NO",
      width: 150,
      align: "center",
    },
  ];

  const columns_detalleFecha = [
    {
      title: "Año",
      dataIndex: "anio",
      key: "anio",
    },
    {
      title: "Mes",
      dataIndex: "mes",
      key: "mes",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
    },
  ];

  if (!data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
        <p style={{ marginTop: 16, fontSize: 16, color: "#888" }}>
          Cargando datos...
        </p>
      </div>
    );
  }

  return (
    <Card style={{ padding: 20 }}>
      <Tag
        color="#D0E0F2"
        style={{
          color: "#145BAD",
          fontSize: "25px",
          fontWeight: "bold",
          padding: "8px 15px",
          borderRadius: "8px",
          textAlign: "center",
          display: "block",
          marginBottom: "15px",
        }}
      >
        INFORME AUTORIZACIÓN DE IMAGEN
      </Tag>
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        {/*filtro departamento */}
        <Col xs={24} sm={8} md={9}>
          <Select
            placeholder="Selecciona un departamento"
            style={{ width: "100%" }}
            value={departamentoSeleccionado}
            onChange={(value) => {
              setDepartamentoSeleccionado(value);
              setMunicipioSeleccionado(null);
            }}
            disabled={!listDepartamento || listDepartamento.length === 0} // Asegura que listMunicipio es válido
            showSearch
            optionFilterProp="children" // busca dentro del texto de las opciones
          >
            {listDepartamento.map((dep) => (
              <Option key={dep} value={dep}>
                {dep}
              </Option>
            ))}
          </Select>
        </Col>

        {/*filtro Municipio */}
        <Col xs={24} sm={8} md={9}>
          <Select
            placeholder="Selecciona un municipio"
            style={{ width: "100%" }}
            value={municipioSeleccionado || undefined} // Evita null
            onChange={(value) => setMunicipioSeleccionado(value)}
            disabled={!listMunicipio || listMunicipio.length === 0} // Asegura que listMunicipio es válido
                            showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
          >
            {listMunicipio?.map((mun) => (
              <Option key={mun} value={mun}>
                {mun}
              </Option>
            ))}
          </Select>
        </Col>

        {/*Restablecer información */}
        <Col xs={24} sm={12} md={2}>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={() => {
              setDepartamentoSeleccionado(null);
              setMunicipioSeleccionado(null);
              setSectorSeleccionado(null);
              setNumeroVisitaSeleccionado(null);
              setRangoFechas(null);
            }}
          ></Button>
        </Col>

        {/* Botón Exportar data */}
        <Col xs={12} sm={6} md={4} lg={4}>
          <Export_autorizacion_imagen></Export_autorizacion_imagen>
        </Col>
      </Row>

      <Card style={{ padding: 20 }}>
        <Tag
          color="#D0E0F2"
          style={{
            color: "#145BAD",
            fontSize: "20px",
            fontWeight: "bold",
            padding: "8px 15px",
            borderRadius: "8px",
            textAlign: "left",
            display: "block",
            marginBottom: "15px",
          }}
        >
          INFORMACIÓN GENERAL
        </Tag>

        <Row gutter={[16]} style={{ marginTop: 20 }}>
          {/* Gráfico 1: Autorizaciones por tipo de autorización aprobada*/}
          <Col xs={24} sm={24} md={24} lg={24}>
            <ChartCard
              title="Número de autorizaciones por tipo"
              data={{
                labels: Object.keys(autorizacionesPorTipo).map(
                  (clave) => descripciones[clave] || clave
                ),
                datasets: [
                  {
                    label: "Tipo autorización",
                    data: Object.values(autorizacionesPorTipo),
                    backgroundColor: "#5B93D3",
                    borderRadius: 5,
                    barThickness: 40,
                  },
                ],
              }}
              backgroundColor="#5B93D3"
            />
          </Col>
        </Row>

        <Row gutter={[16]} style={{ marginTop: 20 }}>
          {/*Tabla de resumen datos generales */}
          <Col xs={24} sm={24} md={8} lg={8}>
            <div style={{ height: "460px", overflowX: "auto", marginTop: 30 }}>
              <Table
                dataSource={autorizacionDetalleFecha}
                columns={columns_detalleFecha}
                rowKey="id"
                pagination={{ pageSize: 10 }}
                bordered
              />
            </div>
          </Col>
          {/* Gráfico 1: Visitas por Departamento o Municipio */}
          <Col xs={24} sm={24} md={12} lg={16}>
            <ChartCard
              title={
                departamentoSeleccionado
                  ? `Número de autorizaciones por municipio en ${departamentoSeleccionado}`
                  : "Número de autorizaciones por departamento"
              }
              data={{
                labels: departamentoSeleccionado
                  ? Object.keys(autorizacionesPorMunicipio)
                  : Object.keys(autorizacionesPorDepartamento),
                datasets: [
                  {
                    label: municipioSeleccionado
                      ? "Municipio"
                      : departamentoSeleccionado
                      ? "Municipio"
                      : "Departamento",
                    data: departamentoSeleccionado
                      ? Object.values(autorizacionesPorMunicipio)
                      : Object.values(autorizacionesPorDepartamento),
                    backgroundColor: "#145BAD",
                    borderRadius: 5,
                    barThickness: 40,
                  },
                ],
              }}
              backgroundColor="#145BAD"
            />
          </Col>
        </Row>

        <Row gutter={[16]} style={{ marginTop: 20 }}>
          {/*Tabla de resumen datos generales */}
          <Col xs={24} sm={24} md={24} lg={24}>
            <Tag
              color="#D0E0F2"
              style={{
                color: "#145BAD",
                fontSize: "25px",
                fontWeight: "bold",
                padding: "8px 15px",
                borderRadius: "8px",
                textAlign: "center",
                display: "block",
                marginBottom: "15px",
              }}
            >
              DETALLE GENERAL
            </Tag>
            <div style={{ overflowX: "auto", marginTop: 30 }}>
              <Table
                dataSource={dataFilter}
                columns={columns}
                rowKey="id"
                scroll={{ y: 500, x: "max-content" }}
                pagination={{
                  current: currentPage, // página actual
                  pageSize: pageSize, // filas por página
                  total: dataFilter.length, // total de registros
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} de ${total} registros`,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                bordered
              />
            </div>
          </Col>
        </Row>
      </Card>
    </Card>
  );
};

export default InformeAutorizacionImagen;
